const openSpanRegex = /<span( |%20)data-hs-token="[.A-z0-9_-]*">/g;
const closeSpanRegex = /<\/span>/g;
const cleanupStyleTags = () => {
  console.log('Cleaning style tags...');
  document.querySelectorAll('style').forEach(styleElement => {
    let innerHTML = styleElement.innerHTML;
    if (openSpanRegex.test(innerHTML) || closeSpanRegex.test(innerHTML)) {
      console.log('Fixing data token span tags found in style tag', styleElement);
      innerHTML = innerHTML.replaceAll(openSpanRegex, '');
      innerHTML = innerHTML.replaceAll(closeSpanRegex, '');
      styleElement.innerHTML = innerHTML;
    }
  });
};
const cleanupSrcAttributes = () => {
  console.log('Cleaning html attributes...');
  // Specifically looking to fix things that use src attributes because we might not
  // be loading css attributes properly
  document.querySelectorAll('[src*="data-hs-token"]').forEach(element => {
    let srcAttribute = element.getAttribute('src');
    if (srcAttribute) {
      srcAttribute = srcAttribute.replaceAll(openSpanRegex, '');
      srcAttribute = srcAttribute.replaceAll(closeSpanRegex, '');
      element.setAttribute('src', srcAttribute);
    }
  });
};

// This function attempts to find places where `data-hs-token` was output into places that could
// break the look of the page. That includes style elements and any src attritube on an any element.
// It does not catch everything, and it does not handle cases where the outer quote chars for an
// attributes conflict with quotes within the rendered value.
export const cleanupInvalidDomIfNeeded = () => {
  // If we are not editing a hub db instance, bail now
  if (window.location.href.indexOf('hubdb_row_id') === -1) {
    return;
  }
  cleanupStyleTags();
  cleanupSrcAttributes();
};